import { CloudinaryImage } from '#src/components/CloudinaryImage';
import HighlightRow from '#src/components/HighlightRow';
import {
  flattenResponsiveImage,
  selectContentType,
  selectField,
  selectFields,
} from '#src/lib/contentful/selectors.mjs';
import UniversalStat from '#src/rows/Stats/UniversalStat.js';

import { H2 } from './Headings.js';
import styles from './Stats.scss';

const statClasses = {
  value: styles.value,
  container: styles.valueContainer,
  description: styles.description,
};

export function Stats({
  stats = [],
  title,
  background,
  mobileBackground,
  padding,
  mobilePadding,
}) {
  const cssVars = {
    '--desktop-padding': padding,
    '--mobile-padding': mobilePadding || padding,
  };
  return (
    <HighlightRow className={styles.container} style={cssVars}>
      {background && (
        <CloudinaryImage
          {...flattenResponsiveImage(background)}
          className={styles.backgroundImage}
        />
      )}
      {mobileBackground && (
        <CloudinaryImage
          {...flattenResponsiveImage(mobileBackground)}
          className={styles.mobileBackgroundImage}
        />
      )}
      {!!title && <H2 className={styles.title}>{title}</H2>}
      <div className={styles.stats}>
        {stats.map((stat) => (
          <UniversalStat
            classNames={statClasses}
            key={selectField('value')(stat)}
            contentTypeId={selectContentType(stat)}
            compact
            {...selectFields(stat)}
          />
        ))}
      </div>
    </HighlightRow>
  );
}
